<template>
    <div>
        <div class="container-fluid" style="background-color: white">
            <h4>รายงานการขาย</h4>
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline">
                        <date-picker range
                                     placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                     v-model="search.date"
                                     :format="changeFormat"
                                     :lang="lang" confirm>
                        </date-picker>
                        <multiselect
                            class="form-control border-0"
                            :options="sellers"
                            label="name"
                            placeholder="ค้นหาเซลล์"
                            v-model="search.sale"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                        <button type="button" class="btn btn-success" @click="searchSaleReport">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="reportCommissionReport(in_com)">
                            <icon name="file-pdf"></icon>
                            รายงานคอมมิชชั่นเซลล์
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="reportCommissionReport(out_com)">
                            <icon name="file-pdf"></icon>
                            รายงานคอมมิชชั่นเซลล์(สินค้านอกบริษัท)
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="reportPromotionSale">
                            <icon name="file-pdf"></icon>
                            รายงานโปรโมชั่นเซลล์
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="reportCnSale">
                            <icon name="file-pdf"></icon>
                            รายงานคืนสินค้า
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="reportRvSale">
                            <icon name="file-pdf"></icon>
                            รายงานยอดเงินรับ
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="showCustomerReportModal">
                            <icon name="file-pdf"></icon>
                            รายงานยอดลูกค้ารายเดือน
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="showProductSaleModal">
                            <icon name="file-pdf"></icon>
                            รายงานยอดขายสินค้าแต่ละเดือน
                        </button>&nbsp;
                        <!--                        <button type="button"-->
                        <!--                                @click="printInvoiceReport"-->
                        <!--                                class="btn btn-primary">-->
                        <!--                            <icon name="print"></icon>-->
                        <!--                            พิมพ์รายงานการขาย-->
                        <!--                        </button>&nbsp;-->
                        <button type="button" class="btn btn-primary" @click="excelQuantitySale">
                            <icon name="file-pdf"></icon>
                            รายงานจำนวนขายเซลล์
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="excelAmountSale">
                            <icon name="file-pdf"></icon>
                            รายงานยอดขายเซลล์
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="reportCommissionReportType">
                            <icon name="file-pdf"></icon>
                            รายงานคอมมิชชั่นเซลล์(เลือกประเภทสินค้า)
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="reportCommissionReportYear">
                            <icon name="file-pdf"></icon>
                            รายงานคอมมิชชั่นเซลล์(รายปี)
                        </button>&nbsp;
                        <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                @click="excelProductQuantitySale">
                            <icon name="file-pdf"></icon>
                            รายงานจำนวนขายเซลล์แยกรายสินค้า
                        </button>&nbsp;
                    </form>
                </div>
            </nav>
            <div style="color: red">**หากไม่ค้นหาจะแสดงข้อมูลรายการขายแค่ของวันนี้**</div>
            <div class="col-sm-12 table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th rowspan="2">เซลล์</th>
                        <th colspan="14">จำนวนขาย
                            <button type="button" v-if="!canViewPurchases || canViewSuperAdmin" class="btn btn-primary"
                                    style="float: right" @click="getPerDay('pdf')">พิมพ์
                            </button>
                        </th>
                        <th rowspan="2" style="border-left-width: 40px;" v-if="!canViewPurchases || canViewSuperAdmin">
                            เซลล์
                        </th>
                        <th colspan="14" v-if="!canViewPurchases || canViewSuperAdmin">ยอดขาย</th>
                    </tr>
                    <tr>
                        <template v-for="thead in type">
                            <th>{{ thead.text }}</th>
                            <!--                            <th v-else>{{thead.text}}</th>-->
                        </template>
                        <template v-for="thead in type" v-if="!canViewPurchases || canViewSuperAdmin">
                            <th v-if="thead.value == 1" style="border-left-width: 40px;">{{ thead.text }}</th>
                            <th v-else>{{ thead.text }}</th>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(seller,index) in seller_amount">
                        <tr>
                            <!---quantity--->
                            <td>
                                <template v-if="seller.sale">
                                    {{ seller.sale.name }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.form">
                                    {{ seller.form.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.glass">
                                    {{ seller.glass.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.spoon">
                                    {{ seller.spoon.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.tube">
                                    {{ seller.tube.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.cup">
                                    {{ seller.cup.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.lid">
                                    {{ seller.lid.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.chopsticks">
                                    {{ seller.chopsticks.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.bottle">
                                    {{ seller.bottle.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.basket">
                                    {{ seller.basket.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.glass_lid">
                                    {{ seller.glass_lid.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.room">
                                    {{ seller.room.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.bowl">
                                    {{ seller.bowl.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.fries">
                                    {{ seller.fries.quantity | amount }}
                                </template>
                            </td>
                            <td>
                                <template v-if="seller.total_price">
                                    <b>{{ seller.total_quantity | amount }}</b>
                                </template>
                            </td>
                            <!---price--->
                            <td style="border-left-width: 40px;" v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.sale">
                                    {{ seller.sale.name }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.form">
                                    {{ seller.form.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.glass">
                                    {{ seller.glass.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.spoon">
                                    {{ seller.spoon.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.tube">
                                    {{ seller.tube.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.cup">
                                    {{ seller.cup.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.lid">
                                    {{ seller.lid.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.chopsticks">
                                    {{ seller.chopsticks.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.bottle">
                                    {{ seller.bottle.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.basket">
                                    {{ seller.basket.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.glass_lid">
                                    {{ seller.glass_lid.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.room">
                                    {{ seller.room.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.bowl">
                                    {{ seller.bowl.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.fries">
                                    {{ seller.fries.total_price | currency }}
                                </template>
                            </td>
                            <td v-if="!canViewPurchases || canViewSuperAdmin">
                                <template v-if="seller.total_price" style="font-weight: bold">
                                    <b>{{ seller.total_price | currency }}</b>
                                </template>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <br/>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal">
            </loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="commission_modal">
            <div style="text-align: center;">
                <h4>รายงานคอมมิชชั่น(เลือกประเภทสินค้า)</h4>
                <br/>
                <div class="row">
                    <b-col class="col-sm-4 text-right">เลือกประเภทสินค้า</b-col>
                    <b-col class="col-sm-8">
                        <multiselect multiple :customLabel="customLabelType" track-by="value"
                                     :options="optionProductType" v-model="commission.product_type"></multiselect>&nbsp;
                    </b-col>
                </div>
                <div class="row">
                    <b-col class="col-sm-4 text-right">เลือกวันที่</b-col>
                    <b-col class="col-sm-8">
                        <date-picker
                            v-model="commission.date"
                            type="date"
                            class="w-100"
                            range
                            confirm
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                        </date-picker>
                    </b-col>
                </div>
                <br>
                <div class="row">
                    <b-col class="col-sm-4 text-right">เลือกเซล</b-col>
                    <b-col class="col-sm-8">
                        <multiselect
                            class="border-0"
                            :options="sellers"
                            label="name"
                            placeholder="ค้นหาเซลล์"
                            v-model="commission.sale_id"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                    </b-col>
                </div>
                <br>
                <button @click="submitModalcommission"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideModalcommission"
                        type="button"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="commission_year_modal">
            <div style="text-align: center;">
                <h4>รายงานคอมมิชชั่น(แยกประเภทสินค้า)</h4>
                <br/>
                <div class="row">
                    <b-col class="col-sm-4 text-right">เลือกปี</b-col>
                    <b-col class="col-sm-8">
                        <date-picker
                            v-model="commissionyear.date"
                            type="year"
                            class="w-100"
                            :format="changeFormat2"
                            :lang="lang"
                            placeholder="เลือกปี">
                        </date-picker>
                    </b-col>
                </div>
                <br>
                <div class="row">
                    <b-col class="col-sm-4 text-right">เลือกเซล</b-col>
                    <b-col class="col-sm-8">
                        <multiselect
                            class="border-0"
                            :options="sellers"
                            label="name"
                            placeholder="ทั้งหมด"
                            v-model="commissionyear.sale_id"
                            multiple
                            :close-on-select=false
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                    </b-col>
                </div>
                <br>
                <button @click="submitModalcommissionYear"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideModalcommissionYear"
                        type="button"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="customer_report">
            <report-customer-sale @submit="reportCustomerSale"></report-customer-sale>
        </b-modal>
        <b-modal hide-header hide-footer ref="product_sale_report">
            <report-product-sale @submit="reportProductSale"></report-product-sale>
        </b-modal>
        <b-modal hide-header hide-footer ref="print_invoice_report">
            <div>
                <print-report-invoice-modal @submit="printInvoiceReport">
                </print-report-invoice-modal>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import moment from "moment";
import {domain} from "../../../util/Constants";
import {canSaleOrdersAllView, canViewPurchases, canViewSuperAdmin} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";
import ReportCustomerSale from "./reportCustomerSale";
import ReportProductSale from "./reportProductSale";
import PrintReportInvoiceModal from "../Invoice/PrintReportInvoiceModal";

export default {
    name: "overview-sale-list",
    components: {
        PrintReportInvoiceModal,
        ReportProductSale,
        ReportCustomerSale,
        Loading,
        DatePicker,
        Multiselect
    },
    created() {
        this.getPerDay('search');
        this.$store.dispatch("Seller/get");
        this.$store.dispatch("OverViewSale/clearSearchForOverview");
    },
    data() {
        return {
            msg: '',
            status_loading: 1,
            seller_amount: [],
            date_week: [],
            type: [
                {text: 'โฟม', value: 1},
                {text: 'แก้ว', value: 2},
                {text: 'ช้อน', value: 3},
                {text: 'หลอด', value: 4},
                {text: 'ถ้วย', value: 5},
                {text: 'ฝา', value: 6},
                {text: 'ตะเกียบ', value: 7},
                {text: 'ขวดน้ำ', value: 8},
                {text: 'เข่ง', value: 9},
                {text: 'แก้ว+ฝา', value: 12},
                {text: 'ห้องเย็น', value: 14},
                {text: 'กระปุก', value: 16},
                {text: 'เฟร้นฟราย', value: 17},
                // { text: 'เบ็ดเตล็ด', value: 11 },
                {text: 'รวม', value: 18},
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            changeFormat2: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? year : null
                },
                parse: (value) => {
                    return value ? moment(value, 'YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            in_com: 'in',
            out_com: 'out',
            commission: {
                sale_id: '',
                product_type: '',
                date: ''
            },
            commissionyear: {
                sale_id: '',
                date: ''
            }
        }
    },
    computed: {
        canSaleOrdersAllView,
        canViewPurchases,
        canViewSuperAdmin,
        ...mapState({
            sellers: state => {
                return state.Seller.data;
            },
            search: state => {
                return state.OverViewSale.seller_search_amount
            },
            user: state => {
                return state.Auth.user;
            },
            optionProductType: state => {
                return [
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
        })
    },
    methods: {
        customLabelType(option) {
            return `${option.text}`
        },
        excelAmountSale() {
            let start_date = "";
            let end_date = "";
            let sale = "";
            if (this.search.date.length > 0) {
                if (this.search.date[0] && this.search.date[1]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
            }
            if (this.canSaleOrdersAllView) {
                if (this.search.sale) {
                    sale = this.search.sale.id
                }
            } else {
                sale = this.user.id
            }
            window.open(domain + '/excelAmountSale?' +
                "sale_id=" + sale +
                "&start_date=" + start_date +
                "&end_date=" + end_date)
        },
        excelQuantitySale() {
            let start_date = "";
            let end_date = "";
            let sale = "";
            if (this.search.date.length > 0) {
                if (this.search.date[0] && this.search.date[1]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
            }
            if (this.canSaleOrdersAllView) {
                if (this.search.sale) {
                    sale = this.search.sale.id
                }
            } else {
                sale = this.user.id
            }
            window.open(domain + '/excelQuantiySale?' +
                "sale_id=" + sale +
                "&start_date=" + start_date +
                "&end_date=" + end_date)
        },
        excelProductQuantitySale() {
            let start_date = "";
            let end_date = "";
            let sale = "";
            if (this.search.date.length > 0) {
                if (this.search.date[0] && this.search.date[1]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
            }
            if (this.canSaleOrdersAllView) {
                if (this.search.sale) {
                    sale = this.search.sale.id
                }
            } else {
                sale = this.user.id
            }
            window.open(domain + '/excelProductQuantiySale?' +
                "sale_id=" + sale +
                "&start_date=" + start_date +
                "&end_date=" + end_date)
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showProductSaleModal() {
            this.$refs.product_sale_report.show();
        },
        hideProductSaleModal() {
            this.$refs.product_sale_report.hide();
        },
        showCustomerReportModal() {
            if (!this.search.sale) {
                alert('กรุณาเลือกเซลล์');
            } else {
                this.$refs.customer_report.show();
            }
        },
        hideCustomerReportModal() {
            this.$refs.customer_report.hide();
        },
        searchSaleReport() {
            this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่'
            this.status_loading = 1;
            this.showLoadingModal();
            this.getPerDay('search');
        },
        getPerDay(type) {
            let start_date = "";
            let end_date = "";
            let sale = "";
            if (this.search.date.length > 0) {
                if (this.search.date[0] && this.search.date[1]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
            }
            if (this.canSaleOrdersAllView || this.canViewPurchases) {
                if (this.search.sale) {
                    sale = this.search.sale.id
                }
            } else {
                sale = this.user.id
            }
            if (type == 'search') {
                this.$store.dispatch("OverViewSale/getPerDay", {
                    start_date: start_date,
                    end_date: end_date,
                    sale_id: sale,
                    type: type
                }).then(res => {
                    this.seller_amount = res;
                    this.hideLoadingModal();
                }).catch(err => {
                    this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ'
                    this.status_loading = 3;
                });
            } else {
                window.open(domain + `/sale_per_day?sale_id=${sale}&start_date=${start_date}&end_date=${end_date}&type=${type}`, '_blank')
            }

        },
        reportCommissionReport(type) {
            if (!this.search.sale) {
                alert('กรุณาเลือกเซลล์ที่ต้องการดูคอมมิชชั่น');
            } else if (this.search.date.length < 1) {
                alert('กรุณาเลือกช่วงวันที่');
            } else {
                this.msg = "กำลังดาวโหลดรายงานคอมมิชชั่นเซลล์ กรุณารอสักครู่"
                this.status_loading = 1;
                this.showLoadingModal();
                let sale_id = this.search.sale.id;
                let start_date = '';
                let end_date = '';
                if (this.search.date.length > 0 && this.search.date[0]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
                let data = {
                    sale_id,
                    start_date,
                    end_date,
                    type: type
                }
                this.$store.dispatch("OverViewSale/downloadCommissionSale", data).then(url => {
                    if (url) {
                        window.open(url, '_blank');
                        this.hideLoadingModal();
                    } else {
                        this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                        this.status_loading = 3;
                        this.showLoadingModal();
                    }
                }).catch(() => {
                    this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
        },
        showModalcommission() {
            this.$refs.commission_modal.show();
        },
        hideModalcommission() {
            this.$refs.commission_modal.hide();
        },
        showModalcommissionYear() {
            this.$refs.commission_year_modal.show();
        },
        hideModalcommissionYear() {
            this.$refs.commission_year_modal.hide();
        },
        reportCommissionReportType() {
            this.showModalcommission()
        },
        reportCommissionReportYear() {
            this.showModalcommissionYear()
        },
        submitModalcommissionYear() {
            let sale_id_list = '';
            if (this.commissionyear.sale_id.length > 0) {
                this.commissionyear.sale_id.forEach((x, i) => {
                    if (i > 0) sale_id_list += ',' + x.id
                    else sale_id_list += x.id
                })
            }
            let data = {
                year: moment(this.commissionyear.date, 'DD-MM-YYYY').format("YYYY"),
                sale_id: sale_id_list,
            }
            window.open(domain + '/excelCommissionYear?' +
                "year=" + data.year +
                "&sale_id=" + data.sale_id)
        },
        submitModalcommission() {
            if (!this.commission.sale_id) {
                alert('กรุณาเลือกเซล')
            } else if (!this.commission.date) {
                alert('กรุณาเลือกวันที่')
            } else if (!this.commission.product_type) {
                alert('กรุณาเลือกประเภทสินค้า')
            } else {
                this.msg = "กำลังดาวโหลดรายงานโปรโมชั่นเซลล์ กรุณารอสักครู่"
                this.status_loading = 1;
                this.showLoadingModal();
                let type_id = '';
                this.commission.product_type.forEach((x, i) => {
                    if (i > 0) type_id += ',' + x.value
                    else type_id += x.value
                })
                let data = {
                    sale_id: this.commission.sale_id.id,
                    date_start: moment(this.commission.date[0]).format("YYYY-MM-DD"),
                    date_end: moment(this.commission.date[1]).format("YYYY-MM-DD"),
                    type_id: type_id
                }
                this.$store.dispatch("OverViewSale/downloadCommissionSaleType", data).then(url => {
                    if (url) {
                        window.open(url, '_blank');
                        this.hideLoadingModal();
                    } else {
                        this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                        this.status_loading = 3;
                        this.showLoadingModal();
                    }
                }).catch(() => {
                    this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
        },
        reportPromotionSale() {
            if (!this.search.sale) {
                alert('กรุณาเลือกเซลล์ที่ต้องการดูโปรโมชั่น');
            } else if (this.search.date.length < 1) {
                alert('กรุณาเลือกช่วงวันที่');
            } else {
                this.msg = "กำลังดาวโหลดรายงานโปรโมชั่นเซลล์ กรุณารอสักครู่"
                this.status_loading = 1;
                this.showLoadingModal();
                let sale_id = this.search.sale.id;
                let start_date = '';
                let end_date = '';
                if (this.search.date.length > 0 && this.search.date[0]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
                let data = {
                    sale_id,
                    start_date,
                    end_date
                }
                this.$store.dispatch("OverViewSale/downloadPromotionSale", data).then(url => {
                    if (url) {
                        window.open(url, '_blank');
                        this.hideLoadingModal();
                    } else {
                        this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                        this.status_loading = 3;
                        this.showLoadingModal();
                    }
                }).catch(() => {
                    this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
        },
        reportCnSale() {
            if (!this.search.sale) {
                alert('กรุณาเลือกเซลล์');
            } else if (this.search.date.length < 1) {
                alert('กรุณาเลือกช่วงวันที่');
            } else {
                this.msg = "กำลังดาวโหลดรายงาน กรุณารอสักครู่"
                this.status_loading = 1;
                this.showLoadingModal();
                let sale_id = this.search.sale.id;
                let start_date = '';
                let end_date = '';
                if (this.search.date.length > 0 && this.search.date[0]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
                let data = {
                    sale_id,
                    start_date,
                    end_date
                }
                this.$store.dispatch("OverViewSale/downloadCnSaleReport", data).then(url => {
                    if (url) {
                        window.open(url, '_blank');
                        this.hideLoadingModal();
                    } else {
                        this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                        this.status_loading = 3;
                        this.showLoadingModal();
                    }
                }).catch(() => {
                    this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
        },
        reportRvSale() {
            if (!this.search.sale) {
                alert('กรุณาเลือกเซลล์');
            } else if (this.search.date.length < 1) {
                alert('กรุณาเลือกช่วงวันที่');
            } else {
                this.msg = "กำลังดาวโหลดรายงาน กรุณารอสักครู่"
                this.status_loading = 1;
                this.showLoadingModal();
                let sale_id = this.search.sale.id;
                let start_date = '';
                let end_date = '';
                if (this.search.date.length > 0 && this.search.date[0]) {
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                } else {
                    this.search.date = [];
                }
                let data = {
                    sale_id,
                    start_date,
                    end_date
                }
                this.$store.dispatch("OverViewSale/downloadRvSaleReport", data).then(url => {
                    if (url) {
                        window.open(url, '_blank');
                        this.hideLoadingModal();
                    } else {
                        this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                        this.status_loading = 3;
                        this.showLoadingModal();
                    }
                }).catch(() => {
                    this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
        },
        reportCustomerSale(value) {
            if (value) {
                this.msg = "กำลังดาวโหลดรายงาน กรุณารอสักครู่"
                this.status_loading = 1;
                this.showLoadingModal();
                let data = {
                    sale_id: this.search.sale.id,
                    month_start: moment(value[0]).format("DD-MM-YYYY"),
                    month_end: moment(value[1]).format("DD-MM-YYYY"),
                }
                //console.log(data)
                this.$store.dispatch("OverViewSale/downloadCustomerSaleReport", data).then(url => {
                    if (url) {
                        window.open(url, '_blank');
                        this.hideLoadingModal();
                    } else {
                        this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                        this.status_loading = 3;
                        this.showLoadingModal();
                    }
                }).catch(() => {
                    this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
            this.hideCustomerReportModal();
        },
        reportProductSale(value) {
            if (value) {
                let date = moment(value.month).format("YYYY-MM-DD");
                this.msg = "กำลังดาวโหลดรายการ กรุณาลองอีกครั้ง"
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("OverViewSale/downloadProductSaleReport", date).then(url => {
                    if (url) {
                        window.open(url, '_blank');
                        this.hideLoadingModal();
                    } else {
                        this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                        this.status_loading = 3;
                        this.showLoadingModal();
                    }
                }).catch(() => {
                    this.msg = "ดาวโหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง"
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
            this.hideProductSaleModal();
        },
        validateDateRange() {
            let dates = [];
            if (this.search.date.length > 0) {
                let currentDate = moment(this.search.date[0]);
                let end_date = moment(this.search.date[1]);
                while (currentDate <= end_date) {
                    dates.push(moment(currentDate).format("YYYY-MM-DD"));
                    currentDate = moment(currentDate).add(1, 'days')
                }
                this.date_week = dates;
            }
        },
        printInvoiceReport(submit) {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let sale_id = '';
            this.validateDateRange();
            // //console.log(this.date_week.length);
            if (this.search.date.length == 0) {
                alert('กรุณาเลือกวันที่ที่ต้องการออกรายงาน')
            }
            // if(this.search.date.length == 0){
            //     alert('กรุณาเลือกวันที่ที่ต้องการออกรายงาน โดยออกรายงานได้ไม่เกิน 7 วัน')
            // }
            // else if(!this.search.sale){
            //     alert('กรุณาเลือกเซลล์ที่ต้องการออกรายงาน')
            // }
            if (this.date_week.length > 60) {
                alert('เลือกวันระหว่างพิมพ์ไม่เกิน 60 วัน เนื่องจากข้อมูลในการออกรายงานมีจำนวนมาก จะทำให้การโหลดมีเวลานานเกินไป');
            } else {
                if (this.search.date.length > 0) {
                    start_date = moment(this.search.date[0]).format('YYYY-MM-DD');
                    end_date = moment(this.search.date[1]).format('YYYY-MM-DD');
                }
                if (this.search.customer) {
                    customer_id = this.search.customer.id
                }
                this.showLoadingModal();
                this.msg = 'กำลังดาวโหลดรายงานการขาย กรุณารอสักครู่...';
                this.status_report = 1;
                let data = {
                    start_date,
                    end_date,
                    customer_id,
                    sale_id,
                };
                this.$store.dispatch("Invoice/reportInvoice", data).then(url => {
                    if (url) {
                        window.open(url);
                        this.hideLoadingModal();
                    } else {
                        this.msg = 'ดาวโหลดรายงานการขายไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                        this.status_report = 3;
                    }
                }).catch(err => {
                    this.msg = 'ดาวโหลดรายงานการขายไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                    this.status_report = 3;
                })
            }
        },
    }
}
</script>

<style lang="scss" scoped>
thead {
    background-color: gainsboro;
    color: black;
}

tbody {
    background-color: white;
}
</style>
